export const generativeAiAppGroupIdCanvasQa = "/:app_group_id/generative_ai/canvas_qa";
